// extracted by mini-css-extract-plugin
export default {"reward":"QJZFZ","rowSpacing":"sDPtl","salary":"csmFp","bonus":"JdoNs","salaryText":"F3crU","bonuses":"g9Iur","bonusText":"strhM"};